import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "src/app/shared/services/api.service";

@Component({
  selector: "app-topbar-new",
  templateUrl: "./topbar-new.component.html",
  styleUrls: ["./topbar-new.component.scss"],
})
export class TopbarNewComponent implements OnInit {
  workspaceName: string = localStorage.getItem("workSpace1") || "";
  workspaceBankAcc: string = localStorage.getItem("workSpaceBankAcc") || "";
  workspaceOwner: string = localStorage.getItem("workSpaceOwner") || "";
  role: string = JSON.parse(localStorage.getItem("currentUser") || "{}").role || "";
  listData: any[] = [];
  activeWorkspace: string = localStorage.getItem("workSpaceCode") || "";
  device_subscription: any = JSON.parse(localStorage.getItem("device_subscription") || "null");

  constructor(private router: Router, private apiService: ApiService) {}

  ngOnInit(): void {
    this.fetchData();
  }

  fetchData() {
    if (this.role === "user") {
      this.apiService.getList("workspaces/basic-list").subscribe({
        next: (res) => {
          this.listData = res["workspaces"] ? res["workspaces"] : [];
        },
      });
    }
  }

  getWorkspaceIdByCode(workspaceCode: string): string {
    const workspace = this.listData.find((data) => data.code === workspaceCode);
    return workspace ? workspace["id"] : "";
  }

  setActiveWorkspace(workspaceCode: string) {
    this.activeWorkspace = workspaceCode;
  }

  changeWorkspace(workspaceCode: string, workspaceName: string) {
    this.activeWorkspace = workspaceCode;
    const workspaceId = this.getWorkspaceIdByCode(workspaceCode);
    localStorage.setItem("workspace", workspaceId);
    localStorage.setItem("workSpaceCode", workspaceCode);
    localStorage.setItem("workSpace1", workspaceName);
    window.location.reload();
  }

  goBack() {
    this.router.navigate(["account/workspace-mobile"]);
  }
}
